import ScreenOptionsEnum from "@models/ScreenOptionsEnum";
import { hasEditAccess } from "@services/ScreenOptionsService";
import ViewAccessService from "@services/ViewAccessService";
import { useMemo } from "react";
import VendorUsers from "../VendorUsers/VendorUsers";
import { useAppContextNonNull } from "@contexts/AppContext";

type Props = {};

export const VendorUsersWrapper = (props: Props) => {
    const { userModel, supplierModel, socket, uiContext } = useAppContextNonNull();

    const isReadOnly = useMemo(() => {
        return !hasEditAccess(ScreenOptionsEnum.ACCOUNT_USERS, userModel, supplierModel, ViewAccessService.UsersVendorsUsers);
    }, [userModel, supplierModel]);

    return (
        <VendorUsers
            socket={socket}
            setActivityIndicator={uiContext.setActivityIndicator}
            notifyFn={uiContext.notifyFn}
            setSidebarComponent={uiContext.setSidebarComponent}
            toggleSidebar={uiContext.toggleSidebar}
            supplierModel={supplierModel}
            userModel={userModel}
            isReadOnly={isReadOnly}
        />
    );
};
